import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { media } from '../helpers';
import Img from 'gatsby-image';

const CollectionPromoItemContainer = styled.div`
    flex: 1 1 100% !important;
    margin-bottom: 40px;
    ${media.medium`margin-bottom: 0px;flex: 0 0 50% !important;`}
    ${media.laptop`flex: 0 0 33.33% !important;`}
    .inner-wrap {
        max-width: 90%;
        margin: 0 auto;
        .image-container {
            position: relative;
            overflow: hidden;

            &.no-image {
                min-height: 400px;
                max-height: 400px;
                ${media.medium`min-height: 430px;max-height: 430px;`}
            }

            .gatsby-image-wrapper {
                img {
                    margin-bottom: 0px;
                }
            }
            .color-bg {
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 5;
            }
            .content-container {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 10;
                height: 100%;
                display: flex;
                align-items: center;

                h3 {
                    padding: 0 20px;
                    color: #fff;
                    font-size: 1.9rem;
                    line-height: 1.1;
                    margin: 0;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
            }
        }
    }
`;

const CollectionPromoItem = ({ promo }) => {
    const { promoLink, promoColor } = promo || {};
    const doesPromoHaveImage = promo.promoImage && promo.promoImage.localFile;

    return (
        <CollectionPromoItemContainer>
            <div className="inner-wrap">
                <Link to={promoLink.url}>
                    <div
                        className={
                            !doesPromoHaveImage
                                ? 'image-container no-image'
                                : 'image-container'
                        }
                    >
                        {doesPromoHaveImage && (
                            <Img
                                fluid={
                                    promo.promoImage.localFile.childImageSharp
                                        .fluid
                                }
                            />
                        )}
                        <div
                            className="color-bg"
                            style={{
                                backgroundColor: `${promoColor}`,
                                opacity: doesPromoHaveImage ? 0.5 : 1,
                            }}
                        ></div>
                        <div className="content-container">
                            <h3>{promoLink.title}</h3>
                        </div>
                    </div>
                </Link>
            </div>
        </CollectionPromoItemContainer>
    );
};

export default CollectionPromoItem;
